import axios from "axios";
import { ElMessageBox, ElMessage } from "element-plus";
const service = axios.create({
  baseURL:
    process.env.NODE_ENV === "development"
      ? "/api"
      : "http://www.fastener-cn.net:80/",
  timeout: 1000000,
});
service.interceptors.request.use(
  (config) => {
    // const token = localStorage.getItem("token") || "";
    // if (token) {
    //   config.header = {
    //     "Content-Type": "application/json;charset=UTF-8",
    //     Authorization: `Bearer${JSON.parse(token)}`,
    //   };
    // } else {
    config.header = {
      "Content-Type": "application/json;charset=UTF-8",
    };
    // }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    // if the custom code is not 20000, it is judged as an error.
    if (res.status !== 200 && res.Blob == "") {
      ElMessage({
        message: res.message || "接口错误",
        type: "error",
        duration: 5 * 1000,
      });

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (
        res.status === 50008 ||
        res.status === 50012 ||
        res.status === 50014
      ) {
        // to re-login
        ElMessageBox.confirm(
          "You have been logged out, you can cancel to stay on this page, or log in again",
          "Confirm logout",
          {
            confirmButtonText: "Re-Login",
            cancelButtonText: "Cancel",
            type: "warning",
          }
        ).then(() => {});
      }
      return Promise.reject(new Error(res.message || "Error"));
      // return res
    }
    if (res.status == 401) {
      console.log("401");
      ElMessage({
        message: res.message || "接口错误",
        type: "error",
        duration: 5 * 1000,
      });
    }
    return res;
  },
  (error) => {
    ElMessage({
      message: error.message,
      type: "error",
      duration: 5 * 1000,
    });
    return Promise.reject(error);
  }
);
export default service;
